// Copies text to the clipboard. Resolves when it was copied, rejects when it
// could not be.
//
// navigator.clipboard only exists on secure pages (HTTPS or localhost) and can
// be refused by the browser, so a bare-IP or plain-HTTP install would copy
// nothing. Then this falls back to selecting the text in a hidden textarea and
// running the copy command. The textarea goes inside the open dialog or
// drawer, if any: their focus trap would otherwise pull focus away from it and
// nothing would be selected.
export default function copyText(text) {
  const value = String(text ?? "");
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(value).catch(() => legacyCopy(value));
  }
  return legacyCopy(value);
}

function legacyCopy(value) {
  return new Promise((resolve, reject) => {
    const active = document.activeElement;
    const DIALOG = ".ant-modal, .ant-drawer-content, [role='dialog']";
    // The dialog the button is in; else the top open one; else the page.
    const open = [...document.querySelectorAll(DIALOG)].filter((el) => el.offsetParent !== null);
    const host = (active && active.closest && active.closest(DIALOG)) || open[open.length - 1] || document.body;
    const ta = document.createElement("textarea");
    ta.value = value;
    ta.setAttribute("readonly", "");
    ta.style.cssText = "position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none;";
    host.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, value.length);
    let ok = false;
    try {
      ok = document.execCommand("copy");
    } catch {
      ok = false;
    }
    ta.remove();
    if (active && typeof active.focus === "function") active.focus();
    ok ? resolve() : reject(new Error("copy failed"));
  });
}
